// @ vendor
const Immutable = require('immutable');

// @ constants
const actionTypes = require('../../../constants/actionTypes');
const { CM_EUR_CURRENCY } = require('../../../constants/constants');

function setInitialState() {
    return Immutable.fromJS({
        mustValidateMinimumAmount: false,
        mustDisplayMinimumAmountLabel: false,
        showGeneralMinAmountMessage: false,
        valid: false,
        accountBalanceInvalid: false,
        accountNumber: '',
        interveners: Immutable.List(),
        availableInterveners: Immutable.List(),
        originalInterveners: Immutable.List(),
        amount: 0,
        minimumAmountIsValid: true,
        amountAccountIsValid: true,
        amountIsValid: true,
        amountDirty: false,
        amountMinimumIsValid: true,
        accountIsValid: true,
        emptyAmount: false,
        validFromAPI: false,
        loading: false,
        customMinimumPurchaseAmount: {
            amount: 0,
            currency: '',
        },
        accountAmount: {
            amount: 0,
            currency: CM_EUR_CURRENCY,
        },
        selectedAccount: {
            productNumber: '',
            contractNumber: '',
        },
    });
}

function minimumAmountIsValid(immState) {
    const mustValidateMinimumAmount = immState.get('mustValidateMinimumAmount');
    const amount = parseFloat(immState.get('amount'));

    if (amount > 0) {
        if (!mustValidateMinimumAmount) {
            return true;
        }

        const minimumAmount = parseFloat(
            immState.getIn(['customMinimumPurchaseAmount', 'amount']),
        );
        return amount >= minimumAmount;
    }

    return false;
}

function validateStep(state) {
    const amount = parseFloat(state.get('amount'));
    const accountBalance = parseFloat(state.getIn(['accountAmount', 'amount']));
    const validAccount = state.get('accountNumber');

    const validAmountMinimum = minimumAmountIsValid(state);

    const validAmountAccount = amount > 0 && amount <= accountBalance;
    const emptyAmount = amount === 0;

    const accountBalanceInvalid = accountBalance <= 0;

    const ready =
        validAmountMinimum &&
        validAmountAccount &&
        validAccount &&
        !accountBalanceInvalid;

    return state.merge({
        valid: ready,
        accountBalanceInvalid: accountBalanceInvalid,
        amountDirty: false,
        amountIsValid: validAmountAccount && validAmountMinimum,
        amountAccountIsValid: validAmountAccount,
        minimumAmountIsValid: validAmountMinimum,
        emptyAmount,
        accountIsValid: !!state.get('accountNumber'),
        showGeneralMinAmountMessage: true,
    });
}

function filterAvailables(currentInterveners = [], originalInterveners = []) {
    const availableInterveners = originalInterveners.filter(intervener => {
        return !currentInterveners.find(originalIntervener => {
            return intervener.get('name') === originalIntervener.get('name');
        });
    });

    return availableInterveners;
}

function parseInterveners(interveners) {
    return interveners.map(intervener => {
        return {
            name: intervener.nombre.trim(),
            type: intervener.desIntervencion.trim(),
            originalType: intervener.desIntervencion.trim(),
            interventionType: intervener.tipoIntervencion,
            interventionForm: intervener.formaIntervencion,
            documentNumber: intervener.numDocumento,
            documentType: intervener.tipoDocumento,
            personNumber: intervener.numPersona,
            personType: intervener.tipPers,
        };
    });
}

function cmWalletBuyStep1Legacy(state = setInitialState(), action) {
    switch (action.type) {
        case actionTypes.CM_VALIDATE_REQUEST:
            return state.set('loading', true);
        case actionTypes.CM_VALIDATE_SUCCESS:
            return state.merge({ validFromAPI: true, loading: false });
        case actionTypes.CM_VALIDATE_FAILURE:
            return state.merge({ validFromAPI: false, loading: false });
        case actionTypes.CM_VALIDATE_STEP:
            return validateStep(state);
        case actionTypes.CM_SET_TYPE:
            return state.merge({
                type: action.payload.type,
            });
        case actionTypes.CM_GET_INTERVENERS_SUCCESS: {
            const nextInterveners = Immutable.fromJS(
                parseInterveners(action.payload.data.intervinientes.dato),
            );
            const interveners = {
                interveners: Immutable.List(nextInterveners),
                originalInterveners: Immutable.List(nextInterveners),
            };
            const newState = state.merge(interveners);
            return newState.merge({
                isFetching: false,
                validFromAPI: false,
            });
        }
        case actionTypes.CM_RESTORE_DEFAULT_INTERVENERS:
            return state.mergeDeep({
                validFromAPI: false,
                interveners: action.payload.originalInterveners,
                availableInterveners: Immutable.List(),
            });
        case actionTypes.CM_SET_ACCOUNT_INTERVENER_NAME: {
            let interveners = state.get('interveners');
            const nextInterveners = interveners.setIn(
                [action.payload.index, 'name'],
                action.payload.name,
            );
            const availableInterveners = filterAvailables(
                nextInterveners,
                action.payload.originalInterveners,
            );

            return state.mergeDeep({
                validFromAPI: false,
                interveners: nextInterveners,
                availableInterveners,
            });
        }
        case actionTypes.CM_SET_ACCOUNT_INTERVENER_TYPE:
            return state
                .setIn(
                    ['interveners', action.payload.index, 'type'],
                    action.payload.type,
                )
                .set('validFromAPI', false);
        case actionTypes.CM_SET_ACCOUNT:
            return state.mergeDeep({
                validFromAPI: false,
                accountNumber: action.payload.accountId,
                accountAmount: { amount: action.payload.accountAmount },
                selectedAccount: {
                    productNumber: action.payload.productNumber,
                    contractNumber: action.payload.contractNumber,
                },
            });
        case actionTypes.CM_SET_AMOUNT:
            return state.merge({
                validFromAPI: false,
                amount: action.payload.amount,
                amountDirty: true,
                showGeneralMinAmountMessage: true,
            });
        case actionTypes.CM_SET_INITIAL_AMOUNT:
            return state.set('amount', action.payload.amount);
        default:
            return state;
    }
}

module.exports = cmWalletBuyStep1Legacy;
